import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'v5/design-system/Badge';
import { SimpleTooltip } from 'v5/design-system/Tooltip';

/**
 * How many units of a workspace section have their own value; the tooltip
 * (and screen readers) say what the number means.
 */
export function OverriddenCountBadge({
  count,
  children
}: {
  count: number;
  children: ReactNode;
}) {
  const { t } = useTranslation('patterns');
  const meaning = t('SchemaForm.badge.overriddenCount', { count });
  return (
    <SimpleTooltip title={meaning}>
      <Badge variant="accent" tone="subtle" size="sm">
        <span aria-hidden="true">{children}</span>
        <span className="sr-only">{meaning}</span>
      </Badge>
    </SimpleTooltip>
  );
}
